import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/AudioPermissionModal.css';

export default function AudioPermissionModal({ isOpen, onAllow, onDeny }) {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  const handleAllow = () => {
    onAllow();
  };

  const handleDeny = () => {
    onDeny();
  };

  return (
    <div className="audio-permission-overlay">
      <div className="audio-permission-modal">
        <div className="audio-permission-icon">
          🔊
        </div>
        
        <h2 className="audio-permission-title">
          {t('audioPermission.title')}
        </h2>
        
        <p className="audio-permission-description">
          {t('audioPermission.description_meiji')}
        </p>
        
        <div className="audio-permission-buttons">
          <button 
            className="audio-permission-button deny"
            onClick={handleDeny}
          >
            {t('audioPermission.deny')}
          </button>
          
          <button 
            className="audio-permission-button allow"
            onClick={handleAllow}
          >
            {t('audioPermission.allow')}
          </button>
        </div>
      </div>
    </div>
  );
}